import { render, staticRenderFns } from "./ChatInputAudioComponent.vue?vue&type=template&id=7a0214ef&scoped=true&"
import script from "./ChatInputAudioComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatInputAudioComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatInputAudioComponent.vue?vue&type=style&index=0&id=7a0214ef&prod&lang=scss&scoped=true&"
import style1 from "./ChatInputAudioComponent.vue?vue&type=style&index=1&id=7a0214ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0214ef",
  null
  
)

export default component.exports